var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-back-top", {
    attrs: {
      target: _vm.getDom
    }
  }, [_c("div", {
    staticClass: "backtop"
  }, [_vm._v("Top")])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };